import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/hukdisService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};



class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'periodeHukdislists'
    defaultOrder = 'punishment_periode_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    
    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            approveUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
            JSON.parse(sessionStorage.getItem(this.historyTable)) :
            {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: this.defaultOrder,
                    order: this.defaultSort
                }
            },
            userdata: JSON.parse(localStorage.getItem('userdata')),
            currentRoleId: localStorage.getItem('currentRoleId')
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    updatestatus = (period_promotion_uuid) => {
        console.log(period_promotion_uuid);
        this.dataTableBloc.createChannel.subscribe((result) => {
          switch (result.status) {
            case apiResponse.COMPLETED:
              if (result.data.status) {
                let response = result.data.response;
                this.setState({
                  //rankItems: reformatRank(response.result),
                });
              }
              break;
            case apiResponse.ERROR:
              break;
            default:
              break;
          }
        });
        this.dataTableBloc.fetchCreate({
            period_promotion_uuid: period_promotion_uuid
          });
      };
    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            // Start Generation Here
            currentRoleId: this.state.currentRoleId,
            employee_uuid: this.state.userdata.employee_uuid,
            is_atasan: this.state.userdata.is_atasan,
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()
        // alert(this.props.currentRoleId);
        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        //this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "punishment_periode_start_date",
            text: "Periode",
            sortable: true,
            cell: record => {
                return reformatDate(record.punishment_periode_date)+" s/d "+ reformatDate(record.punishment_periode_end_date)
            }
        },
        {
            key: "punishment_discipline_count",
            text: "Jumlah Penerima",
            sortable: false,
            cell: record => {
                return record.punishment_discipline_count + ' Orang' 
            }
        },
        {
            key: "punishment_discipline_status_name",
            text: "Status",
            sortable: true,
            cell: record => {
                return <label className="badge rounded-pill bg-soft-info font-size-12" >{record.punishment_discipline_status_name}</label>
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.punishment_periode_id
                const status = record.punishment_periode_status
                return (
                    <Fragment>
                        
                        { record.award_period_approval_status !== 1 &&
                            <Fragment>
                                { accessRole('update') ? 
                                    <span>
                                        {this.props.currentRoleId ==1?
                                        <button
                                        className="btn btn-warning btn-sm"
                                        id={"update-" + thisId}
                                        onClick={() => {
                                                this.setState({
                                                    updateUuid: record.punishment_periode_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-plus"></i>
                                        </button>
                                        :
                                        <button
                                        className="btn btn-primary btn-sm"
                                        id={"update-" + thisId}
                                        onClick={() => {
                                                this.setState({
                                                    updateUuid: record.punishment_periode_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-plus"></i>
                                        </button>
                                        }
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["update" + thisId] : !this.state["update" + thisId]
                                                })
                                            }}
                                        >{this.props.currentRoleId ==1?'Tambah Pegawai':'Lihat Pegawai'}</Tooltip>
                                    </span>
                                                : 
                                    ''
                                }

                                { accessRole('delete') && status == 0 && record.punishment_discipline_count == 0 &&
                                    <span>
                                        <button 
                                            className="btn btn-danger btn-sm" 
                                            type="button"
                                            id={"delete-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    inactiveUuid: record.punishment_periode_uuid,
                                                    confirm: true
                                                })
                                            }}
                                            style={{
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-trash-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["delete" + thisId] : !this.state["delete" + thisId]
                                                })
                                            }}
                                        >Hapus</Tooltip>
                                    </span>
                                }

                                {/* { accessRole('approve') && 
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-" + thisId}
                                            onClick={() => {
                                                this.updatestatus({
                                                    period_promotion_uuid : record.period_promotion_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-user-check"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["approve-" + thisId]} target={"approve-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["approve-" + thisId] : !this.state["approve-" + thisId]
                                                })
                                            }}
                                        >Selesaikan Proses</Tooltip>
                                    </span>
                                } */}


                            </Fragment>
                        }

                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?pegawai&uuid=" + this.state.updateUuid}/>
                : null }
                { this.state.approveUuid !== null &&
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?approveperiode&uuid=" + this.state.approveUuid}/>
                }
            </>
        )
    }

}

export default TableActiveComponent